import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardContent, Grid, Dialog, DialogTitle, DialogContent, IconButton, Typography } from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
// import { useLocation, useNavigate } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import { getPhotosById } from '../../../../asiosConfig';
import Popup from '../../../Popup';

import { Box } from "@mui/material";


export const ViewUserImages = () => {
    const navigate = useNavigate();
    // const location = useLocation();
    // const userId = location.state?.userId;
    const { userId } = useParams();
    const [photos, setPhotos] = useState([]);
    const [currentPhotoIndex, setCurrentPhotoIndex] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [popupData, setPopupData] = useState({ open: false, type: '', message: '' });

    const handleClosePopup = () => {
        setPopupData({ ...popupData, open: false });
    };

    // useEffect(() => {
    //     const fetchPhotos = async () => {
    //         // const token = localStorage.getItem('token');
    //         try {
    //             const response = await getPhotosById({ 'user_id': userId });
    //             if (response.status === 200 || response.status === 201) {
    //                 setPhotos(response.data.data);
    //             } else {
    //                 setPopupData({ open: true, type: 'error', message: "Error Fetching Photos" });
    //             }
    //         } catch (error) {
    //             setPopupData({ open: true, type: 'error', message: "Error Fetching Photos" });
    //         }
    //     };
    //     fetchPhotos();
    // }, [userId]);


    useEffect(() => {
  if (!userId) return;

  const fetchPhotos = async () => {
    try {
      const response = await getPhotosById({ user_id: userId });

      if (response.status === 200 || response.status === 201) {
        setPhotos(response.data.data || []);
      } else {
        setPopupData({
          open: true,
          type: 'error',
          message: 'Error Fetching Photos',
        });
      }
    } catch (error) {
      setPopupData({
        open: true,
        type: 'error',
        message: 'Error Fetching Photos',
      });
    }
  };

  fetchPhotos();
}, [userId]);

    const openModal = (index) => {
        setCurrentPhotoIndex(index);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleNext = () => {
        if (photos.length > 0) {
            setCurrentPhotoIndex((prevIndex) => (prevIndex + 1) % photos.length);
        }
    };

    const handlePrevious = () => {
        if (photos.length > 0) {
            setCurrentPhotoIndex((prevIndex) => (prevIndex - 1 + photos.length) % photos.length);
        }
    };

    return (
        <div className="col-lg-9 col-12">
            <Card className="editProfileBlock">
                <CardHeader
                    avatar={<ArrowBack sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />}
                    title="Photos"
                    titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
                />
                <CardContent>
                    {photos.length === 0 ? (
                        <Typography variant="body1" align="center">No photos found</Typography>
                    ) : (
                        <Grid container spacing={2}>
                            {photos.map((photo, index) => (
                                <Grid item xs={12} sm={6} md={4} key={index}>
                                    {/* <Card> */}
                                    <Card sx={{ borderRadius: "16px", boxShadow: "0 6px 20px rgba(0,0,0,0.08)" }}>

                                        {/* <CardContent sx={{ padding: 1 }}>
                                            <img
                                                src={photo?.photo ? photo.photo : 'No Image'}
                                                alt="Photo"
                                                style={{ width: '100%', height: '270px', cursor: 'pointer', objectFit: 'cover' }}
                                                onClick={() => openModal(index)}
                                            />
                                        </CardContent> */}

                                        <CardContent sx={{ padding: 1 }}>
  <Box
    onClick={() => openModal(index)}
    sx={{
      width: "100%",
      height: "270px",
      borderRadius: "12px",
      overflow: "hidden",
      position: "relative",
      cursor: "pointer",
    }}
  >
    {/* 🔹 BLURRED BACKGROUND */}
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        backgroundImage: `url("${photo?.photo || ""}")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        filter: "blur(18px)",
        transform: "scale(1.2)",
        zIndex: 1,
      }}
    />

    {/* 🔹 MAIN CLEAR IMAGE */}
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        backgroundImage: `url("${photo?.photo || ""}")`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        zIndex: 2,
      }}
    />
  </Box>
</CardContent>

                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    )}
                </CardContent>
            </Card>

            <Dialog
                open={isModalOpen}
                onClose={closeModal}
                maxWidth="md"
                fullWidth
                sx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    },
                    '& .MuiPaper-root': {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        margin: 0,
                        padding: 0,
                    },
                }}
            >
               
                {/* <DialogContent sx={{ textAlign: 'center', position: 'relative' }}>
                    {photos.length > 0 && currentPhotoIndex !== null && photos[currentPhotoIndex] && (
                        <img
                            src={photos[currentPhotoIndex]?.photo || 'No Image'}
                            alt="Current"
                            style={{ maxHeight: '80vh', maxWidth: '100%' }}
                        />
                    )}
                    <IconButton onClick={handlePrevious} sx={{ position: 'absolute', top: '50%', left: 8, transform: 'translateY(-50%)', color: 'white' }}>
                        <ArrowBack />
                    </IconButton>
                    <IconButton onClick={handleNext} sx={{ position: 'absolute', top: '50%', right: 8, transform: 'translateY(-50%)', color: 'white' }}>
                        <ArrowForward />
                    </IconButton>
                </DialogContent> */}


                {/* 🔴 FLOATING CLOSE BUTTON (OUTSIDE IMAGE) */}
<IconButton
  aria-label="close"
  onClick={closeModal}
  sx={{
    position: "fixed",
    top: "44px",
    right: "186px",
    color: "#fff",
    background: "rgba(0,0,0,0.5)",
    backdropFilter: "blur(6px)",
    zIndex: 5,
    "&:hover": {
      background: "rgba(0,0,0,0.7)",
    },
  }}
>
  <CloseIcon />
</IconButton>


                <DialogContent
  sx={{
    textAlign: "center",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "75vh",
    p: 0,
  }}
>
  {photos.length > 0 &&
    currentPhotoIndex !== null &&
    photos[currentPhotoIndex] && (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* 🔹 BLURRED BACKGROUND */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url("${
              photos[currentPhotoIndex]?.photo || ""
            }")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "blur(25px)",
            transform: "scale(1.2)",
            zIndex: 1,
          }}
        />

        {/* 🔹 CLEAR FOREGROUND IMAGE */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url("${
              photos[currentPhotoIndex]?.photo || ""
            }")`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            zIndex: 2,
          }}
        />
      </Box>
    )}

  {/* LEFT ARROW */}
  <IconButton
    onClick={handlePrevious}
    sx={{
      position: "absolute",
      top: "50%",
      left: 20,
      transform: "translateY(-50%)",
      color: "white",
      zIndex: 3,
      background: "rgba(0,0,0,0.4)",
      "&:hover": { background: "rgba(0,0,0,0.6)" },
    }}
  >
    <ArrowBack />
  </IconButton>

  {/* RIGHT ARROW */}
  <IconButton
    onClick={handleNext}
    sx={{
      position: "absolute",
      top: "50%",
      right: 20,
      transform: "translateY(-50%)",
      color: "white",
      zIndex: 3,
      background: "rgba(0,0,0,0.4)",
      "&:hover": { background: "rgba(0,0,0,0.6)" },
    }}
  >
    <ArrowForward />
  </IconButton>
</DialogContent>

            </Dialog>

            <Popup
                open={popupData.open}
                type={popupData.type}
                message={popupData.message}
                onClose={handleClosePopup}
            />
        </div >
    );
};
